import { render, staticRenderFns } from "./MenuQuiz.vue?vue&type=template&id=4cccc125&scoped=true&"
import script from "./MenuQuiz.vue?vue&type=script&lang=js&"
export * from "./MenuQuiz.vue?vue&type=script&lang=js&"
import style0 from "./MenuQuiz.vue?vue&type=style&index=0&id=4cccc125&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cccc125",
  null
  
)

export default component.exports